import React, { createContext, Dispatch, useReducer, useContext } from 'react';
// export const AppContext = React.createContext({
//   gnbLeftButton: 'default',
//   gnbRightButton: 'default',
//   // gnbLeftButtonCallback: null,
//   // gnbRightButtonCallback: null,
//   changeGnbLeftButton: (name: string) => {
//     // changeGnbLeftButton
//   },
//   changeGnbRightButton: (name: string) => {
//     // changeGnbLeftButton
//   },
//   addGnbLeftButtonCallback: (fn: any) => {
//     // addGnbLeftButtonCallback
//   },
//   addGnbRightButtonCallback: (fn: any) => {
//     // addGnbRightButtonCallback
//   }
// });
type AppState = {
  gnbLeftButton: string;
  gnbRightButton: string;
  gnbCenterButton: boolean;
  gnbLeftButtonCallback: any;
  gnbRightButtonCallback: any;
};

type AppAction =
  | { type: 'SET_GNB_CENTER'; isShow: boolean }
  | { type: 'SET_GNB_LEFT'; name: string }
  | { type: 'RESET_GNB_LEFT' }
  | { type: 'SET_GNB_RIGHT'; name: string }
  | { type: 'RESET_GNB_RIGHT' }
  | { type: 'SET_GNB_LEFT_CALLBACK'; cb: any }
  | { type: 'RESET_GNB_LEFT_CALLBACK' }
  | { type: 'SET_GNB_RIGHT_CALLBACK'; cb: any }
  | { type: 'RESET_GNB_RIGHT_CALLBACK' };
type AppDispatch = Dispatch<AppAction>;

function appReducer(state: AppState, action: AppAction): any {
  switch (action.type) {
    case 'SET_GNB_CENTER':
      return {
        ...state,
        gnbCenterButton: action.isShow,
      };
    case 'SET_GNB_LEFT':
      return {
        ...state,
        gnbLeftButton: action.name,
      };
    case 'SET_GNB_RIGHT':
      return {
        ...state,
        gnbRightButton: action.name,
      };
    case 'RESET_GNB_LEFT':
      return {
        ...state,
        gnbLeftButton: null,
      };
    case 'RESET_GNB_RIGHT':
      return {
        ...state,
        gnbRightButton: null,
      };
    case 'SET_GNB_LEFT_CALLBACK':
      return {
        ...state,
        gnbLeftButtonCallback: action.cb,
      };
    case 'RESET_GNB_LEFT_CALLBACK':
      return {
        ...state,
        gnbLeftButtonCallback: null,
      };
    case 'SET_GNB_RIGHT_CALLBACK':
      return {
        ...state,
        gnbRightButtonCallback: action.cb,
      };
    case 'RESET_GNB_RIGHT_CALLBACK':
      return {
        ...state,
        gnbRightButtonCallback: null,
      };
    default:
      throw new Error('app-context.ts/AppReducer] unhandled action');
  }
}
const AppStateContext = createContext<AppState | undefined>(undefined);
const AppDispatchContext = createContext<AppDispatch | undefined>(undefined);

export function AppContextProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const initialState = {
    gnbCenterButton: true,
    gnbLeftButton: 'default',
    gnbRightButton: 'default',
    gnbLeftButtonCallback: null,
    gnbRightButtonCallback: null,
  };
  const [states, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppDispatchContext.Provider value={dispatch}>
      <AppStateContext.Provider value={states}>{children}</AppStateContext.Provider>
    </AppDispatchContext.Provider>
  );
}

export function useAppState(): AppState {
  const state = useContext(AppStateContext);
  if (!state) throw new Error('useAppState] AppProvider not found');
  return state;
}

export function useAppDispatch(): AppDispatch {
  const dispatch = useContext(AppDispatchContext);
  if (!dispatch) throw new Error('useAppDispatch] AppProvider not found');
  return dispatch;
}
